import React from 'react';
import Icon from './Icon';

export default Icon(
  <g>
    <path
      d="M12.5,26.9c0,1.3-0.6,1.9-1.7,2.2C9,29.7,7.1,30.3,5,29.9c-2.2-0.4-3.5-2.2-3.2-4.5c0.4-2.8,1.3-5.4,2.1-8
		c0.2-0.9,0.4-1.9,0.4-2.8c0-1.1-0.6-1.5-1.7-1.7c-0.7,0-1.5,0-2.2,0.4c-0.4,0-0.4,0-0.4-0.6c0.2-0.7,0.6-1.1,1.3-1.5
		c1.7-0.6,3.4-1.1,5-1.1c1.1,0.2,2.1,0.4,3,1.1c1.1,0.9,1.5,2.1,1.3,3.4c-0.2,2.2-0.9,4.3-1.5,6.3c-0.4,1.5-0.9,3-0.9,4.7
		c0,1.1,0.6,1.7,1.7,1.9C10.8,27.3,11.8,27.1,12.5,26.9z"
    />
    <path
      d="M5.6,3.5C5.6,1.5,7.3,0,9.3,0s3.7,1.5,3.7,3.5c0,1.9-1.7,3.5-3.7,3.5C7.3,6.9,5.6,5.4,5.6,3.5z"
    />
  </g>, '0 -5 10 40', 'InfosIcon',
);
